import { createVNode as _createVNode, resolveComponent as _resolveComponent, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "org-lic-comp" }
const _hoisted_2 = /*#__PURE__*/_createVNode("h1", { class: "main-header" }, "Licensing", -1)
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" Need more licenses? Email ")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("kathleen@accidentplan.com")
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" or call ")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("833-831-5288")
const _hoisted_7 = /*#__PURE__*/_createTextVNode(". ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_progress = _resolveComponent("el-progress")
  const _component_el_link = _resolveComponent("el-link")
  const _directive_loading = _resolveDirective("loading")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _hoisted_2,
    _withDirectives(_createVNode(_component_el_progress, {
      class: "lic-bar",
      percentage: _ctx.licPercentage,
      format: _ctx.format
    }, null, 8, ["percentage", "format"]), [
      [_directive_loading, _ctx.fetchState === _ctx.FetchStates.FETCHING]
    ]),
    _createVNode("p", null, [
      _hoisted_3,
      _createVNode(_component_el_link, {
        type: "primary",
        href: "mailto:kathleen@accidentplan.com"
      }, {
        default: _withCtx(() => [
          _hoisted_4
        ]),
        _: 1
      }),
      _hoisted_5,
      _createVNode(_component_el_link, {
        type: "primary",
        href: "tel:+1833-831-5288"
      }, {
        default: _withCtx(() => [
          _hoisted_6
        ]),
        _: 1
      }),
      _hoisted_7
    ])
  ]))
}